import Vue from 'vue'

import vueSlider from '../../node_modules/vue-slider-component/src/vue2-slider.vue';
import RidingForm from './components/RidingForm';
import store from './store/board-fitter-store.js';


//Height Slider
Vue.component('height-input', {
  props: [
    'savedUserProfile',
    'userHeight',
    'userHeightFt',
    'userHeightInchesRemaining',
  ],

  data () {
    return {
      value : 0, //We'll set this on mount
      options: {
        direction: 'vertical',
        width: 12,
        height: 300,
        dotSize: 50,
        speed: 0.4,
        tooltip: 'never',
        startAnimation: true,
        interval: 1,
        min: 95,
        max: 193,
        tooltipDir: 'top',
        data: null,
        eventType: 'auto',
        dotHeight: null,
        dotWidth: null,
        show: true,
        disabled: false,
        piecewise: false,
        usdKeyboard: false,
        enableCross: true,
        piecewiseStyle: null, //Eg, {'background-color': '#333'}
        piecewiseLabel: false,
        reverse: false,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null
      }
    }
  },

  mounted: function() {
    //Set initial height
    this.value = this.savedUserProfile.height.toFixed(0);
  },

  computed: {
    heightCm () {
      store.commit('setUserHeight', this.value); //Update our global stored height
      return parseFloat(this.value);
    },
    upperNudge () {
      return .95*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
    lowerNudge () {
      return .05*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
  },
  components: {
    vueSlider
  },

  template: '\
    <div class="slider-area">\
    <h3 v-bind:class="{ \'nudged\':(value > upperNudge)}">Your Height</h3>\
    <vue-slider v-model="value" v-bind="options"></vue-slider>\
    <div v-bind:class="{ \'nudged\':(value < lowerNudge)}" class="slider-results">\
    <h4 class="main-measurement">{{ userHeightFt }}<span class="unit-type">ft</span> {{ userHeightInchesRemaining }}<span class="unit-type">in</span></h4>\
    <h5 class="sub-measurement">{{ heightCm }}<span class="unit-type">cm</span></h5>\
    </div>\
    </div>\
  ',

});



//Weight Slider
Vue.component('weight-input', {
  props: [
    'savedUserProfile',
    'userWeightLb',
  ],

  data () {
    return {
      value : 0,
      options: {
        direction: 'vertical',
        width: 12,
        height: 300,
        dotSize: 50,
        speed: 0.4,
        tooltip: 'never',
        startAnimation: true,
        interval: .5,
        min: 14,
        max: 115,
        tooltipDir: 'top',
        data: null,
        eventType: 'auto',
        dotHeight: null,
        dotWidth: null,
        show: true,
        disabled: false,
        piecewise: false,
        usdKeyboard: false,
        enableCross: true,
        piecewiseStyle: null,
        piecewiseLabel: false,
        reverse: false,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null
      }
    }
  },


  mounted: function() {
    //Set initial height
    this.value = this.savedUserProfile.weight.toFixed(1);
  },
  computed: {
    weightKg () {
      store.commit('setUserWeight', this.value); //Update our global stored weight
      return parseFloat(this.value).toFixed(1);
    },
    upperNudge () {
      return .95*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
    lowerNudge () {
      return .05*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
  },
  components: {
    vueSlider
  },

  template: '\
    <div class="slider-area">\
    <h3 v-bind:class="{ \'nudged\':(value > upperNudge)}">Your Weight</h3>\
    <vue-slider v-model="value" v-bind="options"></vue-slider>\
    <div v-bind:class="{ \'nudged\':(value < lowerNudge)}" class="slider-results">\
    <h4 class="main-measurement">{{ userWeightLb }}<span class="unit-type">lb</span></h4>\
    <h5 class="sub-measurement">{{ weightKg }}<span class="unit-type">kg</span></h5>\
    </div>\
    </div>\
  ',

});



//Boot Slider
Vue.component('boot-input', {
  props: [
      'savedUserProfile',
      'userBootSizeUsw',
      'userBootSizeMondo',
  ],

  data () {
    return {
      value : 1.5, //initial state, cannot be lower than "min" below.
      options: {
        direction: 'vertical',
        width: 12,
        height: 300,
        dotSize: 50,
        speed: 0.4,
        tooltip: 'never',
        startAnimation: true,
        interval: .5,
        min: 1.5,
        max: 14,
        tooltipDir: 'top',
        data: null,
        eventType: 'auto',
        dotHeight: null,
        dotWidth: null,
        show: true,
        disabled: false,
        piecewise: false,
        usdKeyboard: false,
        enableCross: true,
        piecewiseStyle: null,
        piecewiseLabel: false,
        reverse: false,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        tooltipStyle: null,
        labelStyle: null,
        labelActiveStyle: null
      }
    }
  },

  mounted: function() {
    //Set initial height
    this.value = this.savedUserProfile.bootSize;
  },

  computed: {
    bootSizeUsm () {
      store.commit('setUserBootSize', this.value); //Update our global stored height
      return parseFloat(this.value).toFixed(1);
    },
    upperNudge () {
      return .95*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
    lowerNudge () {
      return .05*(parseFloat(this.options.max) - parseFloat(this.options.min)) + parseFloat(this.options.min);
    },
  },
  components: {
    vueSlider
  },

  template: '\
    <div class="slider-area">\
    <h3 v-bind:class="{ \'nudged\':(value > upperNudge)}">Shoe Size</h3>\
    <vue-slider v-model="value" v-bind="options"></vue-slider>\
    <div v-bind:class="{ \'nudged\':(value < lowerNudge)}" class="slider-results">\
    <h4 class="main-measurement">{{ bootSizeUsm }}<span class="unit-type">US m</span></h4>\
    <h5>{{ userBootSizeUsw }}<span class="unit-type">US w</span> &nbsp; {{ userBootSizeMondo }}<span class="unit-type">cm</span></h5>\
    </div>\
    </div>\
  ',

});



//Sizing form
Vue.component('sizing-form', {
  props: [
    'savedUserProfile',
    'userHeight',
    'userHeightFt',
    'userHeightInchesRemaining',
    'userWeightLb',
    'userBootSizeUsw',
    'userBootSizeMondo',
  ],

  methods : {

    showSizeFields: function() {
        store.commit('setSizesChosen', false);
    }
  },

  components: { 'riding-form' : RidingForm },

  template: '\
      <div class="sizing-area">\
        <div class="sliders-area" v-on:click="showSizeFields">\
            <height-input v-bind:saved-user-profile="savedUserProfile" v-bind:user-height="userHeight" v-bind:user-height-ft="userHeightFt"  v-bind:user-height-inches-remaining="userHeightInchesRemaining" ></height-input>\
            <weight-input v-bind:saved-user-profile="savedUserProfile" v-bind:user-weight-lb="userWeightLb"></weight-input>\
            <boot-input v-bind:saved-user-profile="savedUserProfile" v-bind:user-boot-size-usw="userBootSizeUsw"  v-bind:user-boot-size-mondo="userBootSizeMondo"></boot-input>\
        </div>\
        <riding-form></riding-form>\
        </div>\
        ',
});



var BoardFitter = new Vue({
  el: '#board-fitter-home',
  data: {
    savedUserProfile: initialUserSizing,
    boardSizes: initialUserSizing.boardSizes,
    selfIsLoading: false,
  },
  mounted : function(){
   // We don't need to pull anything from the server. Everything is saved in cookies for now.
    if (this.savedUserProfile.boardSizes.maxLength > 0) {
      store.commit('setSizesChosen', true);
    }
  },
  computed: {
    profileMatchesSaved () {

      if ( this.savedUserProfile.boardSizes.maxLength === 0 ) return false //Because they have no saved profile at all
      if ( this.savedUserProfile.height !== this.pendingProfile.height )  return false
      if ( this.savedUserProfile.weight !== this.pendingProfile.weight )  return false
      if ( this.savedUserProfile.bootSize !== this.pendingProfile.bootSize )  return false
      if ( this.savedUserProfile.terrain !== this.pendingProfile.terrain )  return false
      if ( this.savedUserProfile.beginner !== this.pendingProfile.beginner )  return false

      return true
    },
    sizingTitle () {
      if(this.sizesChosen) {
        return 'Your sizing'
      } else {
        return 'Get Sized'
      }
    },
    userHeight () {
      return store.state.userHeight
    },
    userHeightIn () { //Convert height to inches
      return (this.userHeight/2.54).toFixed(0);
    },
    userHeightFt () {
      return  parseInt(this.userHeightIn/12); //Inches to feet with no remainder
    },
    userHeightInchesRemaining () {
      return this.userHeightIn - (this.userHeightFt * 12); //Get remaining inches after feet taken out
    },
    userWeight () {
      return store.state.userWeight
    },
    userWeightLb () {
      return (this.userWeight * 2.20462).toFixed(0);
    },
    userBootSize () {
      return store.state.userBootSize
    },
    userBootSizeUsw () {
      return (this.userBootSize + 1).toFixed(1);
    },
    userBootSizeMondo () {
      return (this.userBootSize + 18).toFixed(1);
    },
    sizesChosen () {
      return store.state.sizesChosen
    },
    terrain () {
      return store.state.terrain
    },
    beginner () {
      return store.state.beginner
    },
    fittingUrl() {
      return '/fit/'+ this.userHeight + 'h' + this.userWeight + 'w' + this.userBootSizeMondo + 'b'+this.terrain+'t'+(this.beginner ? 1: '')
    },
    pendingProfile () {
      return {
        'height': this.userHeight,
        'weight': this.userWeight,
        'bootSize': this.userBootSize,
        'terrain': this.terrain,
        'beginner': this.beginner,
        'boardSizes': {
          'minLength': this.boardSizes.minLength,
          'maxLength': this.boardSizes.maxLength,
          'minWaist': this.boardSizes.minWaist,
          'maxWaist': this.boardSizes.maxWaist,
          'idealWaist': this.boardSizes.idealWaist,
          'length': this.boardSizes.length,
          'minFlex': this.boardSizes.minFlex,
          'maxFlex': this.boardSizes.maxFlex,
        }
      }
    }
  },
  methods : {
    setSizing: function() {
        store.commit('setSizesChosen', true);
    },

    setFittingDisclaimer: function () {
      setCookie('sdb_fit-disclaimer', 1, 30);
    },

    submitProfile: function() {

      //First, we see if the already has a saved profile and if it's unaltered. If so, we just send them to the result page.
      if(this.profileMatchesSaved) {
        window.location.href = this.fittingUrl;
      }
      else if(getCookie('sdb_fit-disclaimer') < 1) {
        //Check to see if they have acknowledged the disclaimer. If not, show the prompt instead

        var message = "<strong>Please note:</strong>" +
            "<p>These results and recommendations are in early development and are only meant to give you a starting " +
            "point in your snowboard search. " +
            "Do not purchase a snowboard without verifying sizing with your retailer.</p>" +
            "<p class='small'><em>This site requires cookies to remember your fitting info as you navigate.</em></p>";

        var _this = this;
        bootbox.confirm({
          message: message,
          buttons: {
            confirm: {
              label: 'I agree',
              className: 'btn-primary'
            },
            cancel: {
              label: 'Cancel',
            }
          },
          callback: function (result) {
            if (result) {
              _this.setFittingDisclaimer() //Set the cookie so they don't see the prompt again
              _this.submitProfile()
            }
          }
        });
      } else {  //Proceed. They already read the disclaimer

        this.selfIsLoading = true;
        axios.get('api/fitting/?userHeight='+this.userHeight+'&userWeight='+this.userWeight+'&bootSize='+this.userBootSize+'&terrain='+this.terrain+'&beginner='+this.beginner)
            .then((response) => {

              this.boardSizes = response.data;

              var fittingString = JSON.stringify(this.pendingProfile);
              setCookie('steepdb_fitting', fittingString, 600);

              //Let's update our savedUserProfile to match, verifying we are in a "saved" state
              this.savedUserProfile.height = this.pendingProfile.height
              this.savedUserProfile.weight = this.pendingProfile.weight
              this.savedUserProfile.bootSize = this.pendingProfile.bootSize
              this.savedUserProfile.terrain = this.pendingProfile.terrain
              this.savedUserProfile.beginner = this.pendingProfile.beginner
              this.savedUserProfile.boardSizes.minLength = this.pendingProfile.boardSizes.minLength
              this.savedUserProfile.boardSizes.maxLength = this.pendingProfile.boardSizes.maxLength
              this.savedUserProfile.boardSizes.minFlex = this.pendingProfile.boardSizes.minFlex
              this.savedUserProfile.boardSizes.maxFlex = this.pendingProfile.boardSizes.maxFlex
              this.savedUserProfile.boardSizes.minWaist = this.pendingProfile.boardSizes.minWaist
              this.savedUserProfile.boardSizes.maxWaist = this.pendingProfile.boardSizes.maxWaist
              this.savedUserProfile.boardSizes.idealWaist = this.pendingProfile.boardSizes.idealWaist
              this.savedUserProfile.boardSizes.length = this.pendingProfile.boardSizes.length

              window.location.href = this.fittingUrl;

              this.selfIsLoading = false;

            }, (response) => {
              //There was an error
              this.selfIsLoading = false;
            });
      }

    },

  }
});
